export const SECTION_NAMES = {
  HOME: "home",
  ARTISTS: "artists",
  PROGRAM: "program",
  TICKETS: "tickets",
  PARTNERS: "partners",
  ABOUT_US: "about-us",
  LISTEN: "listen",
}
